
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import getUserToken from '../../../helpers/tokenValidation'

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,

    // prepareHeaders is used to configure the header of every request and gives access to getState which we use to include the token from the store
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.loggedUserInfo.access_token
      const token2 = getUserToken()
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
        return headers
      } else {
        headers.set('authorization', `Bearer ${token2}`)
        return headers
      }
    },
  }),
  endpoints: (builder) => ({
    getUserDetails: builder.query({
      query: () => ({
        url: 'api/profile',
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetUserDetailsQuery } = authApi
